import { createFileRoute } from "@tanstack/react-router";

import SignUp from "@/features/auth/Signup";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/sign-up")({
  component: () => (
    <BasicLayout>
      <SignUp />
    </BasicLayout>
  ),
});
